import styled from '@emotion/styled';
import MBDialog from 'components/Elements/MBDialog';
import { Typography } from 'components/Typography';
import { palette, theme } from 'theme';
import pxToEm from 'theme/pxToEm';

export const SchedulingDialog = styled(MBDialog)`
  & #close_modal_button {
    right: ${pxToEm(16)};
    top: ${pxToEm(16)};

    &:hover {
      background-color: ${palette.secondary?.main};
    }
  }

  & .MuiDialog-container > .MuiPaper-root {
    box-shadow: none;
    padding-top: ${pxToEm(32)};
    padding-bottom: 0;
    background: ${palette.common.white};

    ${theme.breakpoints.down('md')} {
      padding-left: 0;
      padding-right: 0;
      padding-bottom: ${pxToEm(25)};
    }

    & .MuiDialogContent-root {
      margin: 0 auto 0;
      min-height: 250px;
    }
  }

  nylas-scheduling::part(nls__language) {
    display: none;
  }
`;

export const Title = styled(Typography)`
  font-size: ${pxToEm(28)};
  font-weight: normal;
  margin-top: ${pxToEm(-15)};
  margin-bottom: ${pxToEm(15)};

  ${theme.breakpoints.down('md')} {
    margin-left: 20px;
  }
`;
